import { useEffect, useMemo, useState } from 'react';
import { MultiSelect, Select } from '@mantine/core';
import { useFetchRemoteData } from '../Hooks/useFetchRemoteData';
import { get } from 'lodash';

export const CustomFilterSelect = ({
	getDataFunc,
	column,
	header,
	type,
	queryPopulate,
}) => {
	const [firstLoad, setFirstLoad] = useState(false);
	const [value, setValue] = useState();

	const query = useMemo(
		() => ({
			distinct: [header.id],
			sort: [`${header.id}:asc`],
			pagination: {
				page: 1,
				pageSize: 999999,
			},
			...(queryPopulate ? { populate: queryPopulate } : {}),
		}),
		[header.id, queryPopulate]
	);

	// fetch the data
	const { data, error, isLoading, refetch } = useFetchRemoteData(getDataFunc, {
		query,
		skip: !firstLoad,
	});

	// set the filter value when the value changes
	useEffect(() => {
		column.setFilterValue(value);
	}, [value]);

	return type === 'multi-select' ? (
		<MultiSelect
			data={
				data?.data 
					? data?.data
						?.map(item => get(item, header.id) ? `${get(item, header.id)}` : null)
						.filter(item => Boolean(item)): []
			}
			// onDropdownOpen={() => setFirstLoad(true)} // Argument is not working for MultiSelect
			onClick={() => setFirstLoad(true)} // workaround to load the data
			value={value}
			onChange={setValue}
			placeholder={
				isLoading
					? 'Cargando...'
					: `Filtrar por ${header.column.columnDef.header}`
			}
			variant='unstyled'
			styles={{
				root: {
					width: '100%',
				},
				wrapper: {
					borderBottom: '1px solid #dee2e6',
					width: '100%',
				},
				input: {
					width: '100%',
				},
			}}
			disabled={isLoading}
			searchable
			clearable
		/>
	) : (
		<Select
			data={
				data?.data ? data?.data?.map(item => `${get(item, header.id)}`) : []
			}
			onDropdownOpen={() => setFirstLoad(true)}
			value={value}
			onChange={setValue}
			placeholder={
				isLoading
					? 'Cargando...'
					: `Filtrar por ${header.column.columnDef.header}`
			}
			variant='unstyled'
			styles={{
				root: {
					width: '100%',
				},
				wrapper: {
					borderBottom: '2px solid #dee2e6',
					width: '100%',
				},
				input: {
					width: '100%',
				},
			}}
			disabled={isLoading}
			searchable
			clearable
		/>
	);
};
